import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import GridControl from "../../../Controls/GridControl"
import {
	GetLocal,
	FetchService,
	Base64Type
} from "../../../Base/BaseControl";

export default function Index(props) {

	const [getServiceResult, setServiceResult] = useState(false);
	const [getSuccessText, setSuccessText] = useState('');
	const [getErrorText, setErrorText] = useState('');

	useEffect(() => {
		if (new URL(window.location.href).searchParams.get("ResCode") == 0) {
			var inputValue = {
				session: GetLocal('EmployeeSession'),
				token: new URL(window.location.href).searchParams.get("token")
			};
			let IPGType = GetLocal("IPGType")
			if (IPGType === 1) {
				FetchService("Owner/Trade/Request/IPGPaymentVerifyByNovin", inputValue, IPGPaymentVerifySuccess);
			} else if (IPGType === 0) {
				FetchService("Owner/Trade/Request/IPGPaymentVerify", inputValue, IPGPaymentVerifySuccess);
			}

		} else {
			IPGPaymentVerifyFail();
		}
	}, []);

	const IPGPaymentVerifySuccess = (ServiceResult) => {
		setSuccessText("پرداخت شما با موفقیت انجام شد")
		setServiceResult(ServiceResult);
	}

	const IPGPaymentVerifyFail = (ServiceResult) => {
		setErrorText("پرداخت شما ناموفق بود")
	}

	const DataGrid = () => {
		return (
			<>
				<br /><br />
				<table cellspacing="0" cellpadding="0" className="table table-bordered table-striped">
					<tbody>
						{getSuccessText != '' &&
							<td colspan="4" className="alert alert-success border-1-black font-weight-bold text-center">{getSuccessText}</td>
						}
						{getErrorText != '' &&
							<td colspan="4" className="alert alert-danger border-1-black font-weight-bold text-center">{getErrorText}</td>
						}
						<tr>
							<th class="text-center">شماره پیگیری</th>
							<th class="text-center">شماره مرجع</th>
							<th class="text-center">مبلغ (ریال)</th>
						</tr>
						<tr>
							<td class="text-center">{getServiceResult.SystemTraceNo}</td>
							<td class="text-center">{getServiceResult.RetrivalRefNo}</td>
							<td class="text-center">{getServiceResult.Amount && getServiceResult.Amount.toLocaleString()}</td>
						</tr>
					</tbody>
				</table>
				<br />
			</>
		)
	}

	return (
		<div>
			<DataGrid />
		</div>
	);
}
